/**
 * Created by rickborst on 01/03/2017.
 */

import Config from 'config';

import {
    convertFromAuthenticationWithCredentials as
        convertSessionFromAuthenticationWithCredentials
} from './session';
import {convertFromAuthentication as convertUserFromAuthentication} from './users';

/**
 * Convert request data to Kaltura's naming.
 *
 * @param {Object} data - Authentication ata.
 * @returns {Object} Transformed data.
 */
function convertForAuthenticationWithCredentials (data) {

    return {
        username: data.username || '',
        password: data.password || '',
        udid: this._presets.udid || '',
        partnerId: this._presets.partnerId || ''
    };
}

/**
 * Parse the response from authentication with credentials request.
 *
 * @param {Object} response - Response data.
 * @returns {Object} Parsed data.
 */
function convertFromAuthenticationWithCredentials (response) {
    let result = response.result,
        sessionData = result.loginSession,
        userData = result.user;

    return {
        session: convertSessionFromAuthenticationWithCredentials(sessionData),
        user: convertUserFromAuthentication(userData)
    };
}


/**
 * Convert request data to Kaltura's naming.
 *
 * @param {Object} session - Session data.
 * @returns {Object} Transformed data.
 */
function convertForLogout (session) {
    return {
        ks: session.token
    };
}

/**
 * Parse the data to get the user's email.
 *
 * @param {Object} email - Email to send the link.
 * @returns {Object} Name, id... Of the user.
 */
function convertForResetPassword (email) {
    const partnerId = Config.dataSources.kaltura.presets.partnerId;

    return {
        partnerId: partnerId,
        username: email
    };
}

/**
 * Parse the data to set the user's new password.
 *
 * @param {string} token - Token received per email.
 * @param {string} password - New password entered by user.
 * @returns {Object} Converted data.
 */
function convertForSetPasswordWithToken (token, password) {
    const partnerId = Config.dataSources.kaltura.presets.partnerId;

    return {
        partnerId: partnerId,
        token: token,
        password: password
    };
}

/**
 * Parse the data to call anonymousLogin.
 *
 * @returns {Object} Converted data.
 */
function convertForAnonymousLogin () {
    const partnerId = Config.dataSources.kaltura.presets.partnerId;

    return {
        partnerId: partnerId,
        udid: this._presets.udid || ''
    };
}

export {
    convertForAuthenticationWithCredentials,
    convertFromAuthenticationWithCredentials,
    convertForLogout,
    convertForResetPassword,
    convertForSetPasswordWithToken,
    convertForAnonymousLogin
};


// WEBPACK FOOTER //
// ./src/js/datasources/kaltura/adapters/authentication.js